export enum SecurityActionTypes {
  LOGIN_USER = 'LOGIN_USER',
  LOGOUT_USER = 'LOGOUT_USER',
  UNAUTH_USER = 'UNAUTH_USER'
}

export enum LoginMode {
  NORMAL = 'NORMAL',
  EMBEDDED = 'EMBEDDED'
}

export interface ISecurityPayload {
  username?: string;
  password?: string;
  token?: string;
  message?: string;
  loginMode: LoginMode;
}

export interface ISecurityLoginAction {
  type: SecurityActionTypes.LOGIN_USER;
  payload: { security: ISecurityPayload };
}

export interface ISecurityLogoutAction {
  type: SecurityActionTypes.LOGOUT_USER;
}

export interface ISecurityUnauthAction {
  type: SecurityActionTypes.UNAUTH_USER;
  payload: { message: string };
}

export type SecurityActions = ISecurityLoginAction | ISecurityLogoutAction | ISecurityUnauthAction;
